module.exports = __webpack_public_path__ + "static/media/transfer_white.2c3e9ab8.svg";